'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { PropertyHelpers } from 'FormsUI/constants/PropertyHelpers';
import { PropertyObjectTypesIds, PropertyObjectTypes } from 'ui-forms-components/constants/PropertyObjectTypes';
import useFieldInRouting from 'FormsUI/components/hooks/routing/useFieldInRouting';
import isPropertyNameHidden from 'forms-utils-lib/utils/properties/isPropertyNameHidden';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HiddenField = () => /*#__PURE__*/_jsx(View, {
  marginInlineStart: "200",
  as: "span",
  children: /*#__PURE__*/_jsx(Tag, {
    use: "thunderdome",
    inline: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'editor.form.formFields.hidden'
    })
  })
});
export const PropertyAnnotationHintName = ({
  name = ''
}) => /*#__PURE__*/_jsx(Box, {
  "data-test-id": "property-annotation-hint-name",
  children: /*#__PURE__*/_jsx(Text, {
    as: "small",
    fontStyle: "italic",
    truncate: true,
    children: name
  })
});
export const PropertyAnnotationHintUITag = ({
  objectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.CONTACT],
  objectTypeLabel = ''
}) => /*#__PURE__*/_jsx(Box, {
  marginInlineStart: "200",
  children: /*#__PURE__*/_jsx(Tag, {
    use: PropertyHelpers[objectTypeId] ? PropertyHelpers[objectTypeId].labelColor : 'thunderdome',
    "data-test-id": "property-annotation-hint-ui-tag",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "editor.form.properties.propertyGroup",
      options: {
        objectTypeLabel
      }
    })
  })
});
export const NameLabel = ({
  fieldType = FieldTypes.TEXT,
  fieldLabel = '',
  required = false
}) => {
  const isRequired = required && FieldTypes.SINGLE_CHECKBOX;
  const id = isRequired ? {
    id: 'required-name-label'
  } : {};
  if (fieldType === FieldTypes.SINGLE_CHECKBOX) {
    return /*#__PURE__*/_jsx(Box, Object.assign({}, id, {
      "data-test-id": "form-field-property-helper",
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: fieldLabel
      })
    }));
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "em",
    "data-test-id": "form-field-property-helper",
    children: fieldLabel
  });
};
export const StatusIndicator = ({
  isUsedInRouting = false,
  shouldShowProfilingStatus = false
}) => {
  if (isUsedInRouting || shouldShowProfilingStatus) {
    return /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(StatusTag, {
        use: "info",
        children: isUsedInRouting ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.form.formFields.redirectToASchedulingPage"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.form.formFields.progressiveProfiling"
        })
      })
    });
  }
  return null;
};
const FormFieldInputLabel = ({
  fieldType = FieldTypes.TEXT,
  objectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.CONTACT],
  name = '',
  fieldLabel = '',
  hasPropertyAnnotationsHintsEnabled = false,
  hidden = false,
  objectType: {
    objectTypeLabel = ''
  } = {},
  shouldShowProfilingStatus = false
}) => {
  const {
    isUsedInRouting
  } = useFieldInRouting({
    name,
    objectTypeId
  });
  const showNameHint = hasPropertyAnnotationsHintsEnabled && !isPropertyNameHidden(name);
  const showHintUITag = hasPropertyAnnotationsHintsEnabled && objectTypeId && objectTypeLabel;
  return /*#__PURE__*/_jsxs(Flex, {
    alignSelf: "start",
    flexWrap: "wrap",
    gap: "100",
    children: [/*#__PURE__*/_jsx(NameLabel, {
      fieldType: fieldType,
      fieldLabel: fieldLabel
    }), showNameHint && /*#__PURE__*/_jsx(PropertyAnnotationHintName, {
      name: name,
      fieldType: fieldType,
      objectTypeId: objectTypeId
    }), showHintUITag && /*#__PURE__*/_jsx(PropertyAnnotationHintUITag, {
      objectTypeId: objectTypeId,
      objectTypeLabel: objectTypeLabel
    }), hidden && /*#__PURE__*/_jsx(HiddenField, {}), /*#__PURE__*/_jsx(StatusIndicator, {
      isUsedInRouting: isUsedInRouting,
      shouldShowProfilingStatus: shouldShowProfilingStatus
    })]
  });
};
export default FormFieldInputLabel;